import { FelaCSS } from '@bridebook/ui';

interface IStyles {
  linkStyle: FelaCSS;
}

const styles = (): IStyles => ({
  linkStyle: {
    display: 'block',
    maxHeight: '100%',
    height: '100%',
  },
});

export default styles;
